



































import Vue from 'vue';
import { FileUploadBox } from '@/components/ds';
import i18n from '@/i18n';

export interface SendDocumentsPersonalEvent {
  selfie: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploaded?: boolean;
  };
  cpf: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploaded?: boolean;
  };
  rg: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploaded?: boolean;
  };
  highSchoolTranscript: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploaded?: boolean;
  };
  highSchoolDiploma: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploaded?: boolean;
  };
  enemGradeProof: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploaded?: boolean;
  };
}

const FIVE_MB_IN_BYTES = 5 * 1024 ** 2;

export default Vue.extend({
  components: {
    FileUploadBox,
  },
  data() {
    return {
      personalFilesUploaded: 0,
      files: {
        selfie: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploaded: false,
        },
        cpf: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploaded: false,
        },
        rg: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploaded: false,
        },
        highSchoolTranscript: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploaded: false,
        },
        highSchoolDiploma: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploaded: false,
        },
        enemGradeProof: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploaded: false,
        },
      } as SendDocumentsPersonalEvent,
      errorMessages: {
        selfie: '',
        cpf: '',
        rg: '',
        highSchoolTranscript: '',
        highSchoolDiploma: '',
        enemGradeProof: '',
      },
      maxFileSize: FIVE_MB_IN_BYTES,
    };
  },
  computed: {
    isJacadCourse(): boolean {
      return this.$store.getters.isJacadCourse;
    },
    visibleFiles(): SendDocumentsPersonalEvent | Omit<SendDocumentsPersonalEvent, 'selfie'> {
      if (this.isJacadCourse) {
        const { selfie, ...rest } = this.files;
        return rest;
      }
      return this.files;
    },
    totalFiles(): number {
      return Object.keys(this.visibleFiles).length;
    },
  },
  methods: {
    documentDeleteHandler(index: keyof SendDocumentsPersonalEvent) {
      this.files[index].fileName = '';
      this.files[index].fileDataUrl = '';
      this.files[index].isDocumentUploaded = false;
      this.errorMessages[index] = '';
      this.personalFilesUploaded--;
      this.emitEvent();
    },
    documentUploadHandler(file: File, index: keyof SendDocumentsPersonalEvent) {
      this.errorMessages[index] = '';
      this.files[index].fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.files[index].fileDataUrl = reader.result as string;
        this.files[index].isDocumentUploaded = true;
        this.personalFilesUploaded++;
        this.emitEvent();
      };
    },
    errorHandler(error: 'type' | 'size', index: keyof SendDocumentsPersonalEvent) {
      this.errorMessages[index] = i18n.t(`fileUploadError.${error}`);
    },
    emitEvent() {
      const sentDocuments = Object.fromEntries(
        Object.entries(this.visibleFiles).filter(([, value]) => value?.isDocumentUploaded),
      );

      const hasSentAllRequiredFiles = Object.entries(this.visibleFiles)
        .filter(([key]) => key !== 'enemGradeProof')
        .every(([, value]) => Boolean(value?.isDocumentUploaded));

      this.$emit('input', sentDocuments, hasSentAllRequiredFiles);
    },
  },
});
